"use client";

import { SimulatorInner } from "@/app/_components/guest-chat/simulator";
import { useRouter } from "next/navigation";
import type { CoreServiceWithPlans } from "@/app/_lib/db/core-service";
import type { SolutionWithInclude } from "@/app/_lib/db/solutions";
import type { ChipItem } from "@/app/_components/guest-chat/service-chips";

interface Props {
  services: Pick<CoreServiceWithPlans, "id" | "title">[];
  solutions: Pick<SolutionWithInclude, "id" | "headTitle">[];
  initialChip?: ChipItem;
}

export default function NewConversationClient({ services, solutions, initialChip }: Props) {
  const router = useRouter();

  return (
    <div className="flex flex-col h-full min-h-0">
      <SimulatorInner
        services={services}
        solutions={solutions}
        type="SALES"
        onClose={() => router.push("/dashboard/messages")}
        initialChip={initialChip}
      />
    </div>
  );
}
